import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { FileTextIcon, HeartPulseIcon, LockIcon, FlowerIcon, MailIcon } from 'lucide-react';
export function WhatYouGet() {
  const features = [{
    icon: <FileTextIcon className="w-6 h-6 text-sage" data-id="element-196" />,
    title: 'Inventario Masivo de Documentos',
    description: 'Dónde está el título de la casa, el acta de nacimiento y los seguros.'
  }, {
    icon: <HeartPulseIcon className="w-6 h-6 text-sage" data-id="element-197" />,
    title: 'Protocolo de Salud y Emergencias',
    description: 'Sus deseos médicos escritos para que nadie tenga que adivinar.'
  }, {
    icon: <LockIcon className="w-6 h-6 text-sage" data-id="element-198" />,
    title: 'Caja Fuerte Digital',
    description: 'Un espacio simple para anotar claves de celular, correos y redes sociales.'
  }, {
    icon: <FlowerIcon className="w-6 h-6 text-sage" data-id="element-199" />,
    title: 'Guía de Deseos Finales',
    description: 'Instrucciones sobre su despedida (música, flores, mensajes) para evitar discusiones familiares.'
  }];
  return <section className="py-20 md:py-32 px-6 bg-sage-light" data-id="element-200">
      <div className="max-w-5xl mx-auto" data-id="element-201">
        <FadeIn data-id="element-202">
          <h2 className="font-serif text-3xl md:text-4xl text-charcoal mb-16 text-center" data-id="element-203">
            ¿Qué incluye el Kit?
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8" data-id="element-204">
          {features.map((feature, index) => <FadeIn key={index} delay={0.1 * index} data-id="element-205">
              <div className="bg-card p-8 rounded-2xl shadow-sm border border-sage/10 flex gap-6 h-full" data-id="element-206">
                <div className="flex-shrink-0 w-12 h-12 rounded-full bg-sage/10 flex items-center justify-center" data-id="element-207">
                  {feature.icon}
                </div>
                <div data-id="element-208">
                  <h3 className="font-serif text-xl font-semibold text-charcoal mb-2" data-id="element-209">
                    {feature.title}
                  </h3>
                  <p className="text-muted leading-relaxed" data-id="element-210">
                    {feature.description}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>

        {/* Bonus Card */}
        <FadeIn delay={0.5} data-id="element-211">
          <div className="bg-gradient-to-br from-cream to-[#fdf9f1] p-8 md:p-10 rounded-2xl shadow-warm-lg border-2 border-gold/30 flex flex-col md:flex-row gap-8 items-center" data-id="element-212">
            <div className="flex-shrink-0 w-16 h-16 rounded-full bg-gold/20 flex items-center justify-center" data-id="element-213">
              <MailIcon className="w-8 h-8 text-gold" data-id="element-214" />
            </div>
            <div data-id="element-215">
              <div className="inline-block px-3 py-1 bg-gold/20 text-charcoal text-sm font-bold tracking-wider uppercase rounded-full mb-3" data-id="element-216">
                Bono Especial
              </div>
              <h3 className="font-serif text-2xl font-semibold text-charcoal mb-2" data-id="element-217">
                Plantillas de "Cartas a mis seres queridos"
              </h3>
              <p className="text-muted text-lg leading-relaxed" data-id="element-218">
                Para dejar mensajes de amor, consejos y recuerdos invaluables a
                sus hijos y nietos.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}